import * as React from "react";
import { IconProps } from "../types";

const WorkflowIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          id="Vector"
          d="M8.25 4.75C9.3546 4.75 10.25 5.6454 10.25 6.75V11.25C10.25 12.3546 11.1454 13.25 12.25 13.25H16"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M3.75 6.75C4.85457 6.75 5.75 5.85457 5.75 4.75C5.75 3.64543 4.85457 2.75 3.75 2.75C2.64543 2.75 1.75 3.64543 1.75 4.75C1.75 5.85457 2.64543 6.75 3.75 6.75Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M13.5 10.5L16.25 13.25L13.5 16"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default WorkflowIcon;
